import { Dispatch, useCallback, useContext } from 'react';
import { connect, useDispatch } from 'react-redux';

import { IErknmFormAgreement } from 'KnmErknmPackage/MainModule/interfaces/IErknmFormAgreement';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { Button } from 'UIPackage/MainModule/components/Button';
import { AgreementStatusEnum } from 'APIPackage/KnmModule/enums/AgreementStatusEnum';
import { getKnmFormRef } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { getDecisionFormRef } from 'DecisionPackage/MainModule/selectors/decisionSelectors';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { AgreementsContext } from 'KnmErknmPackage/ErkmAgreementsModule/AgreementsContext';
import { knmSendAgreement } from 'KnmPackage/MainModule/actions/knmActions';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { decisionSendAgreement } from 'DecisionPackage/MainModule/actions/decisionActions';

interface ISendToApproveButtonProps {
  agreement: IErknmFormAgreement;
  name: string;
}

interface ISendToApproveButtonStoreProps {
  formRefKnm: IKnmFormRef | undefined;
  decisionFormRef: IDecisionFormRef | undefined;
}

const SendToApproveButtonWithoutStore = ({
  agreement,
  name,
  decisionFormRef,
  formRefKnm,
}: ISendToApproveButtonProps & ISendToApproveButtonStoreProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const { isDecision } = useContext(AgreementsContext);

  /**
   * Функция отправки соглашения на согласование
   */
  const sendRequestToChangeStatusToOnApproval = useCallback(() => {
    // @ts-ignore
    (isDecision ? decisionFormRef : formRefKnm)?.current.change(`${name}.status`, AgreementStatusEnum.ON_APPROVAL);
    // @ts-ignore
    (isDecision ? decisionFormRef : formRefKnm)?.current.change(
      `${name}.dateOnApprove`,
      formatDate({ date: new Date(), dateFormat: DATE_FORMAT_LONG_FNS }),
    );
    dispatch(isDecision ? decisionSendAgreement() : knmSendAgreement());
  }, [agreement, isDecision, formRefKnm, decisionFormRef]);

  return (
    <Button
      color="primary"
      text={'Отправить на согласование'}
      id="saveButton"
      type={'button'}
      onClick={sendRequestToChangeStatusToOnApproval}
    />
  );
};

const mapStateToProps = (state: IRootState): ISendToApproveButtonStoreProps => ({
  formRefKnm: getKnmFormRef(state),
  decisionFormRef: getDecisionFormRef(state),
});

export const SendToApproveButton = connect(mapStateToProps)(SendToApproveButtonWithoutStore);
